const divForgotPassword = {
  text: 'Link sent to your email',
  text1: 'Email sent to'
};

export default divForgotPassword;
